import crypto from './instance/cryptoInstance';
export const cryptoInstance = crypto;
